/* eslint-disable default-param-last */
import { SET_ORIGINAL_ANSWERS, SET_SELECTED_ANSWERS, SET_QUIZ_OPTIONS, EDIT_MODEL_OBJ, CHANGE_PRODUCTS_STATUS, CHANGE_PRODUCTS, CHANGE_METRICS, } from "../actions/types";
import { defaultAnswers, defaultQuizOptions, editModeDefaultObj } from "../../components/MyProfile/utils";
const initState = {
    originalAnswers: { ...defaultAnswers },
    selectedAnswers: { ...defaultAnswers },
    quizOptions: { ...defaultQuizOptions },
    editModeObj: editModeDefaultObj,
    isChanged: false,
    productsChanged: [],
    metrics: false,
};
export default function myProfileStateReducer(state = initState, action) {
    switch (action.type) {
        case SET_ORIGINAL_ANSWERS: {
            return {
                ...state,
                originalAnswers: action.payload,
            };
        }
        case SET_SELECTED_ANSWERS: {
            return {
                ...state,
                selectedAnswers: action.payload,
            };
        }
        case SET_QUIZ_OPTIONS: {
            return {
                ...state,
                quizOptions: action.payload,
            };
        }
        case EDIT_MODEL_OBJ: {
            return {
                ...state,
                editModeObj: action.payload,
            };
        }
        case CHANGE_PRODUCTS_STATUS: {
            return {
                ...state,
                isChanged: action.payload,
            };
        }
        case CHANGE_PRODUCTS: {
            return {
                ...state,
                productsChanged: action.payload,
            };
        }
        case CHANGE_METRICS: {
            return {
                ...state,
                metrics: action.payload,
            };
        }
        default:
            return state;
    }
}
